module.exports = __webpack_public_path__ + "img/WhatsApp.714fe54b.svg";